<template>
    <div class="d-lg-flex half bg-white w-100">
      <div 
        class="bg order-1 order-md-2 auth-bg d-none d-lg-block" 
        :style="{'background-image': 'url(' + require('@/assets/images/auth/' + $i18n.locale +  '/welcome-np.svg') + ')'}">
      </div>
      <div class="contents order-2 order-md-1">
            <div class="container">
                <div class="row align-items-center justify-content-center">
                    <div class="col-md-7 text-center">              

                        <div class="cobalt-auth mb-4 text-lg-left" v-if="!code">
                            <h1 style="color: #FF0000;">404</h1>
                            <p>{{ $t('error.error404') }}</p>
                        </div>

                        <div v-if="code">
                            <div class="cobalt-auth mb-4 text-lg-left">
                                <img :src="require('@/assets/images/auth/' + $i18n.locale +  '/invite.svg')" :alt="$t('auth.registration')" />
                                <p class="mt-4">
                                    {{ $t("auth.inviteMessage") }}
                                </p>
                            </div>

                            <div class="cobalt-auth mb-4 text-lg-left">

                                <button type="button" class="btn cobalt-btn-primary btn-lg flex-fill mb-4" @click="tryToJoin" :class="{ 'disabled' : isLoading }" v-if="loggedIn">
                                    <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" v-if="isLoading"></span>
                                    {{ $t("auth.join") }}
                                </button>

                                <p v-if="!loggedIn">
                                    {{ $t("auth.youNeed") }} <a :href="'../register?invite=' + code">{{ $t("auth.register").toLowerCase() }}</a>, {{ $t("auth.ifNotRegistered") }}<br />
                                    {{ $t("auth.or") }} <a :href="'../login?invite=' + code">{{ $t("auth.login").toLowerCase() }}</a>, {{ $t("auth.ifAlreadyRegistered") }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> 
</template>

<script>
import { mapActions } from 'vuex';
import { useUserStore } from '@/stores/userStore'

export default {
    data() {
        return {
            isLoading: false,
            loggedIn: false  
        }
    },
    computed: {
        userStore() {
            return useUserStore()
        },
        isAuthenticated() {
            return this.userStore.isAuthenticated;
        },
        code() {
            return this.$route.query.code || null;
        },
        from() {
            return this.$route.query.from || null;
        } 
    },
    methods: {
        ...mapActions('company', ['sendInvitation']),

        async tryToJoin() {
            this.isLoading = true;
            let data = {
                'code': this.code
            };

            let result = await this.sendInvitation(data);

            if (result) {
                this.$router.push('/');
            } else {
                this.$router.push('/invite');
            }
            this.isLoading = false;
        },
        async checkUserLoggedIn() { 
            this.loggedIn = await this.isAuthenticated
        }
    },
    created() {
        this.checkUserLoggedIn()
    }
}
</script>
